var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "wscn-http404" }, [
      _c("div", { staticClass: "bullshit" }, [
        _c(
          "div",
          {
            staticClass: "bullshit__oops",
            staticStyle: {
              "margin-left": "20px",
              "margin-top": "20px",
              "font-size": "20px",
            },
          },
          [_vm._v("欢迎光临 " + _vm._s(_vm.JavaMerInfo.realName))]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }